import { motion } from "motion/react";
import type { ReactNode } from "react";

function FieldNotice({
  className,
  message,
}: {
  className?: string;
  message?: ReactNode;
}) {
  return !message ? null : (
    <motion.div
      className={`rounded-md mt-2 ${className ? className : ""}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      key={typeof message === "string" ? message : undefined}
    >
      <div className="flex">
        <div className="mx-1">
          <div className={`text-base`}>{message}</div>
        </div>
      </div>
    </motion.div>
  );
}

export default FieldNotice;
